var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v("組織資料設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'TemplateList'
      }
    }
  }, [_vm._v("通知樣板管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEditing ? '編輯' : '新增'))])], 1)], 1)])]), _c('b-form', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', {
    attrs: {
      "title": _vm.isEditing ? "".concat(_vm.organizationName, "\u7DE8\u8F2F\u901A\u77E5\u6A23\u677F") : "".concat(_vm.organizationName, "\u65B0\u589E\u901A\u77E5\u6A23\u677F")
    }
  }, [_c('b-card-body', [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Key"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "readonly": ""
    },
    model: {
      value: _vm.template.key,
      callback: function callback($$v) {
        _vm.$set(_vm.template, "key", $$v);
      },
      expression: "template.key"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Notification Type (選擇 LINE 時可以預覽 Flex Card)"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.template.notification_type,
      callback: function callback($$v) {
        _vm.$set(_vm.template, "notification_type", $$v);
      },
      expression: "template.notification_type"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("請選擇")]), _c('b-form-select-option', {
    attrs: {
      "value": "line"
    }
  }, [_vm._v("LINE")]), _c('b-form-select-option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("EMAIL")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "required": "",
      "disabled": ""
    },
    model: {
      value: _vm.template.type,
      callback: function callback($$v) {
        _vm.$set(_vm.template, "type", $$v);
      },
      expression: "template.type"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("請選擇")]), _c('b-form-select-option', {
    attrs: {
      "value": "json"
    }
  }, [_vm._v("JSON")]), _c('b-form-select-option', {
    attrs: {
      "value": "html"
    }
  }, [_vm._v("HTML")])], 1)], 1), _c('b-row', [_vm.template.notification_type === 'line' ? _c('b-form-group', {
    staticClass: "col-12 col-sm-6 col-lg-3",
    attrs: {
      "label": "Live Preview"
    }
  }, [_c('div', {
    staticClass: "p-2",
    staticStyle: {
      "background-color": "#849ebf"
    }
  }, [_c('div', {
    attrs: {
      "id": "preview"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lineFlexCard)
    }
  })])]) : _vm._e(), _c('b-form-group', {
    staticClass: "col-12 col-sm-6 col-lg-9",
    attrs: {
      "label": "Value"
    }
  }, [_vm.template.type === 'json' ? _c('editor', {
    attrs: {
      "width": "100%",
      "height": "200px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.template.value,
      callback: function callback($$v) {
        _vm.$set(_vm.template, "value", $$v);
      },
      expression: "template.value"
    }
  }) : _c('b-form-textarea', {
    attrs: {
      "placeholder": "請輸入參數內容",
      "rows": "6",
      "max-rows": "25"
    },
    model: {
      value: _vm.template.value,
      callback: function callback($$v) {
        _vm.$set(_vm.template, "value", $$v);
      },
      expression: "template.value"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")]), !_vm.isShow ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }